module.exports = __webpack_public_path__ + "static/media/Spice.1f5e44d1.jpg";